import { Model } from "vuex-fetch-factory";

export interface FileEntryRaw {
  relation_id: number;
  project_id: number;
  main_project_id: number;
  archive_id: number;
  description: string;
  category: string;
  archive_date: string;
  extension: string;
}

export class FileEntryModel implements Model<FileEntryModel, FileEntryRaw> {
  public relation_id = 0;
  public project_id = 0;
  public main_project_id = 0;
  public archive_id = 0;
  public description = "";
  public category = "";
  public archive_date = "";
  public extension = "";

  public getNew(): FileEntryModel {
    return new FileEntryModel();
  }

  public fillModel(raw: FileEntryRaw): this {
    this.relation_id = raw.relation_id;
    this.project_id = raw.project_id;
    this.main_project_id = raw.main_project_id;
    this.archive_id = raw.archive_id;
    this.description = raw.description;
    this.category = raw.category;
    this.archive_date = raw.archive_date;
    this.extension = raw.extension;

    return this;
  }

  public getRaw(): FileEntryRaw {
    return {
      relation_id: this.relation_id,
      project_id: this.project_id,
      main_project_id: this.main_project_id,
      archive_id: this.archive_id,
      description: this.description,
      category: this.category,
      archive_date: this.archive_date,
      extension: this.extension,
    };
  }

  public link(): string {
    let base = `api/projectsupload/`;
    if (this.main_project_id > 0) {
      base += `${this.main_project_id}/sub/${this.project_id}`;
    } else {
      base += String(this.project_id);
    }
    const l = `${base}/archive/${this.archive_id}/download/${encodeURI(
      this.description
    )}`;

    if (l.endsWith("." + this.extension)) return l;
    return l + "." + this.extension;
  }
}
